/* ============================================================
   Embedded Designz — Sticky Add to Cart Required-Field Guard
   File: assets/ed-sticky-atc-fix.js
   Loaded in theme.liquid AFTER theme.js, sitewide (all product pages).

   Intercepts native 'submit' on product forms (capture phase) and blocks
   the add when a VISIBLE Easify required field (data-required="1") is
   empty, scrolling it into view.

   REVISION HISTORY:
   - Passes 1-3 (2026-07-12): see snippets/ed-patch-notes.liquid. Easify
     fields live in a sibling block of the <form>, inside
     div.product-info__block-list, marked data-required="1".
   - Pass 4 (2026-10-03): FIX — the guard also counted HIDDEN conditional
     fields (e.g. "Name (Back)" and "Font", which only show when
     "Name on Back? = Yes"). When a customer picks a size, the theme
     re-renders the product block and Easify's own button is replaced by
     the theme's submit button, so this guard runs — and it silently
     blocked every add on products with hidden conditional required
     fields (Custom White T-Shirt). Confirmed live in the browser: with
     hidden fields skipped, the item adds with all properties.
     Now: a field is only enforced if its Easify option container is
     visible.

   GOTCHA: always read the form id via getAttribute('id') — form.id can
   resolve to the hidden <input name="id">.
   ============================================================ */

(function () {
  function isShown(field) {
    var box = field.closest('[class*="tpo_option-container"]') || field;
    if (!box.offsetParent && box.getClientRects().length === 0) return false;
    var cs = window.getComputedStyle(box);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var formId = form && form.getAttribute ? form.getAttribute('id') : null;
      if (!formId || formId.indexOf('product-form') !== 0) return;

      var container = form.closest('.product-info__block-list') || form;
      var requiredFields = container.querySelectorAll('[data-required="1"]');

      for (var i = 0; i < requiredFields.length; i++) {
        var field = requiredFields[i];
        if (!isShown(field)) continue; // hidden conditional field — not required right now

        var isEmpty =
          field.type === 'checkbox' || field.type === 'radio'
            ? !field.checked
            : !field.value || field.value.trim() === '';

        if (isEmpty) {
          event.preventDefault();
          event.stopPropagation();

          var box = field.closest('[class*="tpo_option-container"]') || field;
          box.scrollIntoView({ behavior: 'smooth', block: 'center' });

          field.dispatchEvent(new Event('input', { bubbles: true }));
          field.dispatchEvent(new Event('change', { bubbles: true }));
          field.dispatchEvent(new Event('blur', { bubbles: true }));
          return;
        }
      }
    },
    true
  );
})();
